import { render, staticRenderFns } from "./AllPersonalNotificationPopup.vue?vue&type=template&id=698f44a6"
import script from "./AllPersonalNotificationPopup.vue?vue&type=script&lang=js"
export * from "./AllPersonalNotificationPopup.vue?vue&type=script&lang=js"
import style0 from "./AllPersonalNotificationPopup.vue?vue&type=style&index=0&id=698f44a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports